import React from "react";

function SnapDraftResults({ draftedByUser }) {
  return (
    <div className="app-wrapper">
      <h1 className="main-title">Draft Results</h1>
      <div className="styled-info-modal">
        {Object.entries(draftedByUser).map(([username, picks]) => (
          <div key={username} className="draft-user-box">
            <h3 className="draft-user-name">{username}</h3>
            <div className="drafted-card-grid">
              {picks.map((pick) => (
                <div key={pick.cardId} className="drafted-card">
                  <img src={pick.cardhtml} alt={pick.cardname} className="drafted-card-img" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SnapDraftResults;
